<template>
  <div>
    <b-tabs class="w-tabs">
      <b-tab :title="language.name" :key="language.code" v-for="language in languages">
        <RecommendationForm :onlyRead="onlyRead" :language="language.code" :domainId="domainId"
                            :status-complete="statusComplete" :competentAuthorityIds="competentAuthorityIds"
                            @success="$emit('success')" @reload="updateData" :header-id="cloneHeaderId"
                            :detail="getDetailByLanguage(language.code)"/>
      </b-tab>
    </b-tabs>
    <template v-if="recommendation">
      <hr/>
      <b-row>
        <b-col lg="3">
          <p class="mb-1">{{$t('CREATED_BY')}}:  {{recommendation.created_by}}</p>
        </b-col>
        <b-col lg="3">
          <p class="mb-1">
            {{$t('CREATED_AT')}}:  {{recommendation.created_at | formatDateTime}}
          </p>
        </b-col>
        <template v-if="recommendation.updated_by">
          <b-col lg="3">
            <p class="mb-1">
              {{$t('UPDATED_BY')}}:  {{recommendation.updated_by}}
            </p>
          </b-col>
          <b-col lg="3">
            <p class="mb-1">
              {{$t('UPDATED_AT')}}:  {{recommendation.updated_at | formatDateTime}}
            </p>
          </b-col>
        </template>
      </b-row>
    </template>
  </div>

</template>

<script>


import RecommendationForm from "@/components/recommendation/RecommendationForm.vue";
import {fetchRecommendation} from "@/services/public";
import {cloneDeep} from "lodash";
import {formatDateTime} from "@/filters/formatDates";

export default {
  name: "RecommendationLanguageWrapper",
  props: {
    header: {
      type: Object
    },
    onlyRead: {
      type: Boolean,
      default: false
    }
  },
  components: {RecommendationForm},
  filters: {
    formatDateTime
  },
  data() {
    return {
      languages: [
        { code: 'bs', name: this.$t('BA') },
        { code: 'hr', name: this.$t('HR')  },
        { code: 'sr', name: this.$t('SR')  },
      ],
      selectedLanguage: 'bs',
      cloneHeaderId: null,
      recommendation: null,
      domainId: null,
      statusComplete: null,
      competentAuthorityIds: [],
    }
  },
  methods: {
    selectLanguage(language){
      this.selectedLanguage = language;
    },
    async updateData(header_id) {
      await this.setData(header_id);
      this.$emit('success');
    },
    setData(header_id) {
      this.loading = true;
      fetchRecommendation(header_id).then((response) => {
        this.recommendation = response.data;
        this.cloneHeaderId = response.data.id;
      }).finally(() =>{
        this.loading = false;
      })
    },
    getDetailByLanguage(language) {
      if(this.recommendation && this.recommendation.details && this.recommendation.details.length > 0) {
        return this.recommendation.details.find((el) => el.language === language)
      }
      return null;
    }
  },
  watch: {
    recommendation: {
      handler(recommendationObject) {
        if(recommendationObject && recommendationObject.details && recommendationObject.details.length > 0) {
          const detail = recommendationObject.details[0];
          this.statusComplete = recommendationObject.status_complete ? recommendationObject.status_complete : null;
          if(detail) {
            this.domainId = detail.domain && detail.domain.id ? detail.domain.id : null;
            this.competentAuthorityIds = detail.competent_authorities ? detail.competent_authorities.map((el) => el.id) : [];
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  async mounted() {
    if(this.header) {
      const { header_id } = this.header;
      if(header_id) {
        this.cloneHeaderId = cloneDeep(header_id);
        await this.setData(header_id);
      }
    }
  }
}
</script>
<style >
.tab-content {
  border: none;
}
</style>
